import { jwtDecode } from 'jwt-decode';


// Utility: Check if token is expired
export const isTokenExpired = (token) => {
  try {
    const { exp } = jwtDecode(token);
    return Date.now() >= exp * 1000;
  } catch (e) {
    console.error("Error decoding token:", e);
    return true;
  }
};

// Utility: Get expiration time in ms
export const getTokenExpiration = (token) => {
  try {
    const { exp } = jwtDecode(token);
    return exp * 1000; // Convert to milliseconds
  } catch (e) {
    console.error("Error decoding token:", e);
    return null;
  }
};